import { atom } from "recoil";

export const reportDataState = atom({
  key: "reportDataState",
  default: [],
}); 